import { render, staticRenderFns } from "./PriceDialog.vue?vue&type=template&id=11dd7a36&"
import script from "./PriceDialog.vue?vue&type=script&lang=js&"
export * from "./PriceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports